<template>
	<v-ons-page class="webview-pain-note-report">
		<div class="content">
			<sorry-page v-if="isError" @reload="getData" />
			<pain-note-report v-else-if="isMount" />
		</div>
	</v-ons-page>
</template>

<script>
// Vuex
import { mapActions, mapGetters } from 'vuex'
import { SET_USER_ID, SET_USER_TOKEN, SET_IS_WEBVIEW, SET_USER_DATA, SET_PREMIUM_TYPE } from '../store/modules/common/mutation-types'

// ライブラリ
import cmnConst from '@/assets/js/constant.js'

// Compornents
import PainNoteReport from '@/views/PainNoteReport'
import SorryPage from '@/views/SorryPage'

export default {
	name: 'WebviewPainNoteReport',
	components: {
		PainNoteReport,
		SorryPage
	},
	data () {
		return {
			isError: false,
			isMount: false,
			userId: null,
			userToken: null
		}
	},
	created () {
		// アプリのwebviewはスマパスのS3に置くので、スマパスのみ。現状スゴ得ではルーティングされないのでスゴ得アクセスのエラー判定はしない
		this.SET_IS_WEBVIEW(true)
		// URLパラメータをチェック
		const state = this.$route.query.state ? this.$route.query.state.toString() : ''
		const stateArray = state.split(cmnConst.SEPARATOR)
		if (state === 'error' || state === '') {
			// 認証エラー
			console.log('state error: ', state)
			this.isError = true
		} else if (stateArray.length !== 2) {
			// 認証パラメータエラー
			console.log('state length error: ', state)
			this.isError = true
		} else {
			this.userId = stateArray[0]
			this.userToken = stateArray[1]
			this.SET_USER_ID(this.userId)
			this.SET_USER_TOKEN(this.userToken)

			// APIリクエスト処理
			this.getData()
		}
	},
	mounted () {
	},
	computed: {
		// map Vuex getters
		...mapGetters('common', ['userData', 'premiumType'])
	},
	methods: {
		// map Vuex actions
		...mapActions('common', [SET_USER_ID, SET_USER_TOKEN, SET_IS_WEBVIEW, SET_USER_DATA, SET_PREMIUM_TYPE]),

		// データ取得処理
		getData () {
			// 状態の初期化
			this.isError = false
			this.isMount = false

			// NOTE: ユーザー情報と課金タイプを取得したら子コンポーネントをマウントする（必ずここで取得するのでユーザー情報/課金タイプがあるかどうかの判定はしない）
			const SET_USER_DATA = this.SET_USER_DATA({
				user_id: this.userId,
				user_token: this.userToken
			})
			const SET_PREMIUM_TYPE = this.SET_PREMIUM_TYPE({
				user_id: this.userId,
				user_token: this.userToken
			})
			Promise.all([SET_USER_DATA, SET_PREMIUM_TYPE]).then(res => {
				console.log('userData: ', this.userData)
				console.log('premiumType: ', this.premiumType)
				this.isMount = true
			}).catch(error => {
				// ユーザー情報取得エラー
				console.log('userData error: ', error)
				this.isError = true
			})
		}
	}
}
</script>

<style lang="scss" scoped>
@import "../assets/sass/variable";

.webview-pain-note-report {
	width: 100%;
	height: 100%;
	overflow: hidden;

	/deep/ .page__content { top: 0; }
}
</style>
